import { Button, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  highLightText: {
    color: "#892193",
    fontSize: "14px",
    cursor: "pointer",
    "&:hover": {
      color: "#892193",
    },
  },
}));

const SaveSoundAndCancel = ({ handleCloseUploadSounds }) => {
  const classes = useStyles();

  const cancelUploadSound = () => {
    handleCloseUploadSounds();
  };

  return (
    <div
      className={`ml-5 mt-5 d-flex flex-column flex-grow-1 align-items-center text-transform-none
                 `}>
      <Button
        type="submit"
        className="sr-btn mr-2 ml-2 w-100 contained-btn"
        style={{ textTransform: "none" }}>
        {"Save Sound"}
      </Button>
      <span
        onClick={cancelUploadSound}
        className={`mt-8 ${classes.highLightText} ${classes.label}`}>
        Cancel
      </span>
    </div>
  );
};

export default SaveSoundAndCancel;
